import { normalizeUserName, UserNameInput } from './normalizeUserName';
import _ from 'lodash';

/**
 * @param input The username input.
 * @param fallbackLetters The fallback letters.
 */
export function userAvatarLetters(
    input: UserNameInput,
    fallbackLetters: string
): string {
    const normalized = normalizeUserName(input);

    // Try to the the letters from the first name.
    if (normalized.first) {
        const firstChar: string = normalized.first[0];
        const secondCharSource =
            normalized.last.main ??
            normalized.last.full ??
            normalized.first.substring(1) ??
            fallbackLetters;

        const secondChar = secondCharSource[0];

        return _.upperCase(firstChar + secondChar);
    }

    if (normalized.full) {
        return _.upperCase(normalized.full.substring(0, 2));
    }

    return fallbackLetters;
}
